import { Cross2Icon, InfoCircledIcon } from "@radix-ui/react-icons";
import {
  Popover,
  Theme,
  IconButton,
  Button,
  Text,
  Flex,
  Separator,
} from "@radix-ui/themes";
import { InfoItem } from "@/components/info-item";
import { useSchedules } from "@/virtual-store/hooks/useSchedules";
import { calibrationTunnel } from "@/virtual-store/state";

export function LayoutInfoButton() {
  const { activeSchedule: planogramActiveSchedule } = useSchedules({
    queryKey: "planogramSchedules",
  });
  const { activeSchedule: zoneActiveSchedule } = useSchedules({
    queryKey: "zoneHistorySchedules",
  });

  return (
    <Popover.Root>
      <Popover.Trigger>
        <Button
          variant="soft"
          color="gray"
          size="3"
          radius="large"
          className="px-3"
        >
          <InfoCircledIcon width={20} height={20} />
        </Button>
      </Popover.Trigger>
      <Popover.Content className="p-0" width="402px" side="top">
        <Theme>
          <Flex px="4" py="2" justify="between" align="center">
            <Flex align="center">
              <InfoCircledIcon color="gray" />
              <Text ml="2" size="1" color="gray">
                Layout info
              </Text>
            </Flex>
            <Popover.Close aria-label="Close">
              <IconButton variant="ghost" color="gray">
                <Cross2Icon width={16} height={16} />
              </IconButton>
            </Popover.Close>
          </Flex>
          <Separator size="4" />
          <div className="px-4 pb-2">
            {planogramActiveSchedule && (
              <>
                <Text size="1" weight="bold">
                  Planogram:
                </Text>
                <InfoItem label="ID" value={planogramActiveSchedule.id} />
                <InfoItem
                  label="Description"
                  value={planogramActiveSchedule.description}
                />
                <InfoItem
                  label="Created at"
                  value={planogramActiveSchedule.from_datetime}
                />
              </>
            )}

            <calibrationTunnel.Out />

            {zoneActiveSchedule && (
              <>
                <Text size="1" weight="bold">
                  Zones:
                </Text>
                <InfoItem label="ID" value={zoneActiveSchedule.id} />
                <InfoItem
                  label="Description"
                  value={zoneActiveSchedule.description}
                />
                <InfoItem
                  label="Created at"
                  value={zoneActiveSchedule.from_datetime}
                />
              </>
            )}
          </div>
        </Theme>
      </Popover.Content>
    </Popover.Root>
  );
}
